import { PageLocatorMap } from '../types/PageLocatorMap';

export const dashboardApplicationPage = {
  alert: {
    duplicateApplication: 'dashboard-application.alert.duplicate-application',
    retryFailedSubmission:
      'dashboard-application.alert.retry-failed-submission',
  },
  header: {
    backButton: 'dashboard-application.header.back-button',
    drawerButton: 'dashboard-application.header.drawer-button',
    root: 'dashboard-application.header.root',
  },
  main: {
    bannerSectionRoot: 'dashboard-application.main.banner-section-root',
    contactSectionEmployeeEmail:
      'dashboard-application.main.contact-section-employee-email',
    contactSectionEmployeeName:
      'dashboard-application.main.contact-section-employee-name',
    contactSectionEmployeePhone:
      'dashboard-application.main.contact-section-employee-phone',
    contactSectionH4: 'dashboard-application.main.contact-section-h4',
    contactSectionRoot: 'dashboard-application.main.contact-section-root',
    progressSectionEmptyText:
      'dashboard-application.main.progress-section-empty-text',
    progressSectionH3: 'dashboard-application.main.progress-section-h3',
    progressSectionRoot: 'dashboard-application.main.progress-section-root',
    progressSectionStepper:
      'dashboard-application.main.progress-section-stepper',
    progressSectionViewAllButton:
      'dashboard-application.main.progress-section-view-all-button',
    root: 'dashboard-application.main.root',
    taskSectionActionButton:
      'dashboard-application.main.task-section-action-button',
    taskSectionDescription:
      'dashboard-application.main.task-section-description',
    taskSectionH1: 'dashboard-application.main.task-section-h1',
    taskSectionH2: 'dashboard-application.main.task-section-h2',
    taskSectionRoot: 'dashboard-application.main.task-section-root',
    vehicleImage: 'dashboard-application.main.vehicle-image',
  },
} as const satisfies PageLocatorMap;
